import { verifyOAuthTokenApi } from "@/features/auth/services/verify-oauth-token-api";
import { AppRoutes } from "@/routes/config";
import { showError } from "@/utils/error";
import { logout } from "@/utils/logout";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Generic OAuth handoff callback for the admin app.
 */
export const AuthCallbackPage: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isProcessing = useRef(false);

  useEffect(() => {
    const token = searchParams.get("token");
    const redirectUrl = searchParams.get("redirectUrl");

    if (!token) {
      logout();
      navigate(AppRoutes.login, { replace: true });
      return;
    }

    // Prevent double execution in StrictMode (the token is single-use).
    if (isProcessing.current) return;
    isProcessing.current = true;

    const exchangeToken = async () => {
      try {
        await verifyOAuthTokenApi({ token });
        // Only follow internal redirect targets; anything else falls back to home.
        navigate(redirectUrl && redirectUrl.startsWith("/") ? redirectUrl : AppRoutes.home, { replace: true });
      } catch (error) {
        showError(error);
        logout();
        navigate(AppRoutes.login, { replace: true });
      }
    };

    exchangeToken();
  }, [searchParams, navigate]);

  return (
    <Stack alignItems="center" justifyContent="center" height="100vh" gap={2}>
      <CircularProgress />
      <Typography>ログイン中...</Typography>
    </Stack>
  );
};
